import AttachmentSecondaryContent from './AttachmentSecondaryContent';

export default AttachmentSecondaryContent;
